import { createTeleporter } from 'react-teleporter';

const ModalsPortal = createTeleporter();

export default ModalsPortal;
